/**
 * Zentrale, fachliche Fehlermeldungen für die Session-/OAuth-Prüfung des
 * Mandantenportals.
 *
 * Hintergrund: Das Backend (`backend-public/app/security.py#validate`) wirft
 * bei einem abgelaufenen SessionToken (Inaktivität > 20 Min) `RequestTimeout`
 * → HTTP 408. Der Body ist technisch/leer, daher wird die Meldung allein
 * anhand des Statuscodes bestimmt.
 */

/** Fachliche Meldung bei abgelaufener Session (HTTP 408). */
export const SESSION_EXPIRED_MESSAGE = 'Ihre Session ist abgelaufen.';

/** Generische Meldung für unbekannte/technische Fehler. */
export const GENERIC_ERROR_MESSAGE =
  'Es ist ein unbekannter Fehler aufgetreten. Möglicherweise ist der Dienst vorübergehend offline.';

/**
 * Mappt den HTTP-Statuscode der OAuth-/Session-Prüfung (`GET /api/oauth`) auf
 * eine für den Mandanten verständliche Meldung.
 *
 * Wichtig: Nur eindeutige Session-/Auth-Fälle erhalten eine spezifische
 * Meldung. Alle übrigen Statuscodes (inkl. Netzwerkfehler → `status = 0`)
 * fallen bewusst auf die bisherige generische Meldung zurück.
 */
export function getOAuthErrorMessage(status: number): string {
  switch (status) {
    // 408: Session wegen Inaktivität abgelaufen.
    // 401: Token ungültig/nicht mehr autorisiert — für den Mandanten
    // ebenfalls eine abgelaufene Session (Verhalten wie bisher).
    case 408:
    case 401:
      return SESSION_EXPIRED_MESSAGE;
    case 404:
      return 'Die Anmeldedaten konnten nicht gefunden werden. Bitte überprüfen Sie den Anmeldename und das Passwort';
    case 403:
      return 'Ihr Konto wurde deaktiviert!';
    default:
      return GENERIC_ERROR_MESSAGE;
  }
}
